module.exports = __webpack_public_path__ + "static/img/24.61cb746.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/loading/img/24.png
// module id = y/zA
// module chunks = 0